import { sendErrorToServices } from 'lib/logging';
import { getHost } from 'lib/util';
import { useEffect } from 'react';

export function useStreamHostTracking({
  player,
  ready,
  mainContentSrc,
  playerTalkData,
  service,
  youtubeID,
  onStreamHost
}: {
  player: HTMLVideoElement | null;
  ready: boolean;
  mainContentSrc: string | null | undefined;
  // TODO: actually type this in the graphql layer
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  playerTalkData: any;
  service: string;
  youtubeID?: string | unknown;
  onStreamHost: (host: string) => void;
}): void {
  useEffect(() => {
    try {
      if (service === 'internal') {
        // Try to get the host from mainContentSrc first, then fall back to playerTalkData
        const streamUrl =
          mainContentSrc || playerTalkData?.resources?.hls?.stream;

        // Only proceed if we have a player and it's ready, or if we're forcing a host value
        if ((player && ready) || !streamUrl) {
          const host = getHost(streamUrl);
          onStreamHost(host);
        }
      }

      // For YouTube, ensure we always have a host value
      if (service === 'youtube' && youtubeID) {
        onStreamHost('youtube.com');
      }
    } catch (error) {
      sendErrorToServices('Stream Host Tracking Error', error);
      onStreamHost('unknown host');
    }
  }, [
    mainContentSrc,
    player,
    ready,
    service,
    youtubeID,
    playerTalkData,
    onStreamHost
  ]);
}
